<template>
  <div
    id="song-player"
    :class="activeSeasonContentForSchoolLevel.schoolLevel.slug"
  >
    <div
      v-for="song in routedDay.songs"
      :key="song.slug"
      class="calendar-sheet__song karaokePlayer-view mt-[1.5vh]"
      :data-tracking-url-song="song.vocalMix.trackingUrl"
    >
      <div
        class="calendar-sheet__song-wrapper bg-school-level rounded-full py-1 text-white flex justify-between items-center"
      >
        <div
          class="calendar-sheet__song-label font-[300] basis-auto grow-0 shrink-0 pl-[15px] pr-[7.5px]"
        >
          {{ song.title }}
        </div>
        <div
          class="audioPlayer-calendar calendar-sheet__song-player flex items-center min-w-[200px] p-[5px] bg-none"
        >
          <song-player
            :song="song.vocalMix"
            v-model:playing="song.playing"
            @update:playing="onUpdatePlaying($event, song)"
            v-model:volume="volume"
            v-model:muted="muted"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import SongPlayer from "../../../media/music/song/SongPlayer.vue";

export default {
  name: "CalendarSheetSongs",
  components: {
    SongPlayer,
  },
  data() {
    return {
      volume: 75,
      muted: false,
    };
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel", "routedDay"]),
  },
  watch: {
    routedDay(newDay, oldDay) {
      // Unset tracking markers and playing state on the old day's songs.
      oldDay.songs?.forEach((song) => {
        song.tracked = false;
        song.playing = false;
      });
    },
    volume(volume) {
      window.localStorage.setItem("volume", volume);
    },
  },
  mounted() {
    this.applyMemorizedVolume();
  },
  updated() {
    this.applyMemorizedVolume();
  },
  methods: {
    applyMemorizedVolume() {
      this.volume = Number(window.localStorage.getItem("volume") ?? 75);
    },
    onUpdatePlaying(playing, targetSong) {
      if (!playing) {
        // We don't care if anyone stops playing.
        return;
      }

      // Track playback.
      if (!targetSong.tracked && targetSong.vocalMix?.trackingUrl) {
        navigator.sendBeacon(targetSong.vocalMix.trackingUrl);
        targetSong.tracked = true;
      }

      // However, if someone does *start* playing, then we stop all other players.
      this.routedDay.songs
        .filter((song) => song.slug !== targetSong.slug)
        .forEach((song) => (song.playing = false));
    },
  },
};
</script>

<style lang="css">
.calendar-sheet__song {
  & .bg-player-control-default {
    @apply bg-white;
  }
  & .hover\:bg-player-control-darkened:hover {
    @apply bg-lightGray;
  }
  & .group:hover .group-hover\:bg-player-control-darkened {
    @apply bg-lightGray;
  }
  & .text-player-control-default {
    @apply text-white;
  }
}
</style>
